import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { EnumCreator } from '@leverege/api-attributes'
import { Popup } from '@leverege/ui-elements'
import Util from './Util'

class EnumEditor extends React.Component {

  static TYPE = EnumCreator.typeName()

  static propTypes = {
    attribute : PropTypes.object,
    // eslint-disable-next-line react/no-unused-prop-types
    name : PropTypes.string,
    value : PropTypes.string,
    // eslint-disable-next-line react/no-unused-prop-types
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
    this.state = {
      attrEnum : null
    }
  }

  componentDidMount( props ) {
    const { dispatch, attribute, device, project } = this.props
    let projectId
    if ( device ) {
      projectId = device.projectId
    } else if ( project ) {
      projectId = project.id
    }

    dispatch( async ( dispatch, getState, { api } ) => {
      try {
        const attrEnum = await api.project( projectId ).enum( attribute.enumType ).get()
        this.setState( { attrEnum } )
      } catch ( err ) {
        console.log( 'failed to get enum for attribute', err )
      }
    } )
  }

  onClickValue = ( { data } ) => {
    this.onChange( data, null )
  }

  getEnumValues( enums ) {
    if ( !enums ) return null

    const values = Object.values( enums ).map( e => (
      <Popup.Item
        key={e.value}
        eventData={e.value}
        onClick={this.onClickValue}>
        {e.name}
      </Popup.Item>
    ) )

    values.unshift(
      <Popup.Item
        key="null"
        eventData={null}
        onClick={this.onClickValue}>
        Clear (set to null)
      </Popup.Item>
    )
    return values
  }

  render() {
    const { attribute : attr, value } = this.props
    const { attrEnum } = this.state
    if ( attr == null ) {
      return <div />
    }

    return (
      <div>
        <Popup
          title={value || 'Set Enum Value'}>
          {this.getEnumValues( attrEnum?.values )}
        </Popup>
      </div>
    ) 
  }
}

export default connect( ( state ) => {
  return {
    project : state.project
  }
} )( EnumEditor )
